import axiosInstance from '../config/axios.js';

const BASE = '/ml-agent-commissions';

const mlAgentCommissionService = {
  listAgents: async () => {
    const res = await axiosInstance.get(`${BASE}/agents`);
    return res.data;
  },
  getSummary: async (params = {}) => {
    const res = await axiosInstance.get(`${BASE}/summary`, { params });
    return res.data;
  },
  listUnpaid: async (params = {}) => {
    const res = await axiosInstance.get(`${BASE}/unpaid`, { params });
    return res.data;
  },
  listPaid: async (params = {}) => {
    const res = await axiosInstance.get(`${BASE}/paid`, { params });
    return res.data;
  },
  pay: async (payload) => {
    const res = await axiosInstance.post(`${BASE}/pay`, payload);
    return res.data;
  },
};

export default mlAgentCommissionService;
